<p-card class="w-full">

  <h2 class="text-2xl font-semibold text-color-700 border-b pb-2 mb-4">
   INFORMACIÓN DEL CLIENTE
  </h2>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-4  p-4 rounded-lg border border-surface-200 mb-6">

    <div class="flex flex-col">
      <span class="text-sm text-color-500 font-medium">Número de Cuenta</span>
      <span class="text-base font-semibold text-color-800">{{ dataModal?.IdPqrs }}</span>
    </div>

    <div class="flex flex-col">
      <span class="text-sm text-color-500 font-medium">Nombre</span>
      <span class="text-base font-semibold text-color-800">
        {{ dataModal?.PrimerNombre }} {{ dataModal?.SegundoNombre }}
        {{ dataModal?.PrimerApellido }} {{ dataModal?.SegundoApellido }}
      </span>
    </div>

  </div>

  <h2 class="text-2xl font-semibold text-color-700 border-b pb-2 mb-4">
    INFORMACIÓN DE PQRS
  </h2>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-4  p-4 rounded-lg border border-surface-200">

    <div class="flex flex-col">
      <span class="text-sm text-color-500 font-medium">Código PQR</span>
      <span class="text-base font-semibold text-color-800">{{ dataModal?.CodGlobal }}</span>
    </div>

    <div class="flex flex-col">
      <span class="text-sm text-color-500 font-medium">Número Radicado</span>
      <span class="text-base font-semibold text-color-800">{{ dataModal?.CodRadicado }}</span>
    </div>

    <div class="flex flex-col">
      <span class="text-sm text-color-500 font-medium">Fecha Radicación</span>
      <span class="text-base font-semibold text-color-800">
        {{ dataModal?.FechaRadicacion | date: 'yyyy-MM-dd' }}
      </span>
    </div>

    <div class="flex flex-col">
      <span class="text-sm text-color-500 font-medium">Fecha Vencimiento</span>
      <span class="text-base font-semibold text-color-800">
        {{ dataModal?.FechaVencimiento | date: 'yyyy-MM-dd' }}
      </span>
    </div>

    <div class="flex flex-col">
      <span class="text-sm text-color-500 font-medium">Nombres Suscriptor</span>
      <span class="text-base font-semibold text-color-800">
        {{ dataModal?.PrimerNombre }} {{ dataModal?.SegundoNombre }}
        {{ dataModal?.PrimerApellido }} {{ dataModal?.SegundoApellido }}
      </span>
    </div>

    <div class="flex flex-col">
      <span class="text-sm text-color-500 font-medium">Email</span>
      <span class="text-base font-semibold text-color-800">{{ dataModal?.Email }}</span>
    </div>

    <div class="flex flex-col">
      <span class="text-sm text-color-500 font-medium">Celular</span>
      <span class="text-base font-semibold text-color-800">{{ dataModal?.Celular }}</span>
    </div>

    <div class="flex flex-col">
      <span class="text-sm text-color-500 font-medium">Dirección Predio</span>
      <span class="text-base font-semibold text-color-800">{{ dataModal?.Direccion }}</span>
    </div>

    <div class="flex flex-col">
      <span class="text-sm text-color-500 font-medium">Nombre Reclamante</span>
      <span class="text-base font-semibold text-color-800">
        {{ dataModal?.PrimerNombre }} {{ dataModal?.PrimerApellido }}
      </span>
    </div>

    <div class="flex flex-col">
      <span class="text-sm text-color-500 font-medium">Dirección Correspondencia</span>
      <span class="text-base font-semibold text-color-800">{{ dataModal?.Direccion }}</span>
    </div>

    <div class="flex flex-col">
      <span class="text-sm text-color-500 font-medium">Tipo PQR</span>
      <span class="text-base font-semibold text-color-800">{{ dataModal?.TipoPqr_Texto }}</span>
    </div>

    <div class="flex flex-col">
      <span class="text-sm text-color-500 font-medium">Estado</span>
      <span class="text-base font-semibold text-color-800">{{ dataModal?.Estado_Texto }}</span>
    </div>

    <div class="flex flex-col md:col-span-2">
      <span class="text-sm text-color-500 font-medium">Observación</span>
      <span class="text-base font-semibold text-color-800 whitespace-pre-line">
        {{ dataModal?.DescripcionPqr }}
      </span>
    </div>

  </div>

  <!-- BOTONES -->
  <div class="w-full flex justify-end mt-6 gap-3">
    <p-button 
      label="Cancelar" variant="outlined"
      icon="pi pi-times"
      severity="danger"
      (click)="onCancelar()"
      class="px-4 py-2 border-round-lg">
    </p-button>
  </div>

</p-card>
